<nz-spin [nzSpinning]="isSpinning">
  <div class="sales-portal-container">
    <div class="turnover-detail">
      <div class="detail-setting-header">
        <nz-breadcrumb>
          <nz-breadcrumb-item (click)="navigate('/sales-portal/workshop-acquisition')" style="cursor: pointer">Workshop
            Acquisition Overview
          </nz-breadcrumb-item>
          <nz-breadcrumb-item>Details</nz-breadcrumb-item>
        </nz-breadcrumb>
        <div class="title">Workshop Acquisition Details</div>
        <div class="key-value-box">
          <div class="key-value-item">
            <div class="key">Dealer Code</div>
            <div class="value ml20">{{ detailInfo.dealerCode }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Dealer Name</div>
            <div class="value ml20">{{ detailInfo.dealerName }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Target Year</div>
            <div class="value ml20">{{ detailInfo.targetYear }}</div>
          </div>
        </div>
      </div>

      <div class="target-section-detail">
        <sp-circular-progress
          class="bar"
          [text]="'Achievement Rate'"
          [progress]="salesPortalService.dealerTargetSummaryInfo.customerAchievedRate"
        ></sp-circular-progress>
        <div>
          <div class="still-to-go">
            <span class="key">Still to GO</span>
            <span class="value"
                  [class.value-0]="salesPortalService.dealerTargetSummaryInfo.customerStillToGo === 0">
            {{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.customerStillToGo) }}
          </span>
          </div>
          <div class="flex-v-center">
            <div class="card-item-row mr30">
              <div class="card-item">
                <div class="header header-light"></div>
                <div class="content-key">Workshop Acquisition Target Quantity</div>
                <div
                  class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.targetCustomer) }}
                </div>
              </div>
            </div>
            <div class="card-item-row">
              <div class="card-item">
                <div class="header header-dark"></div>
                <div class="content-key">YTD Actual Workshop Acquisition</div>
                <div
                  class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.actualCustomer) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        

      </div>
      <div style="margin-top: 40px"></div>
      <nz-table
        class="detail-table"
        [nzData]="detailInfo.customerConfigurationList"
        [nzFrontPagination]="false"
        nzTableLayout="fixed"
      >
        <thead>
        <tr>
          <th nzWidth="200px"></th>
          <th nzAlign="center" *ngIf="detailInfo.expandCustomerSplitMethod !== 'BY_YEAR'">Total</th>
          <th *ngFor="let data of salesPortalService.transposeTableData(detailInfo.customerConfigurationList).name"
              nzAlign="center"
          >
            {{ data }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Target. {{ detailInfo.targetYear }}</td>
          <td
            *ngIf="detailInfo.expandCustomerSplitMethod !== 'BY_YEAR'"
            nzAlign="center"
            nzEllipsis
            [title]=" salesPortalService.formatThousands(detailInfo.targetCustomer)"
          >{{ salesPortalService.formatThousands(detailInfo.targetCustomer) }}
          </td>
          <td
            *ngFor="let data of salesPortalService.transposeTableData(detailInfo.customerConfigurationList).targetAmount"
            nzAlign="center"
            nzEllipsis
          >
              <span
                [title]=" salesPortalService.formatThousands(data)"> {{ salesPortalService.formatThousands(data) }}</span>
          </td>
        </tr>
        <tr>
          <td>Actual. {{ detailInfo.targetYear }}</td>
          <td
            *ngIf="detailInfo.expandCustomerSplitMethod !== 'BY_YEAR'"
            nzAlign="center"
            nzEllipsis
            [title]=" salesPortalService.formatThousands(detailInfo.actualCustomer)"
          >{{ salesPortalService.formatThousands(detailInfo.actualCustomer) }}
          </td>
          <td
            *ngFor="let data of salesPortalService.transposeTableData(detailInfo.customerConfigurationList).actualAmount"
            nzAlign="center"
            nzEllipsis
          >
              <span
                [title]="salesPortalService.formatThousands(data)"> {{ salesPortalService.formatThousands(data) }}</span>
          </td>
        </tr>
        <tr>
          <td>Act. {{ detailInfo.targetYear }} vs. Target. {{ detailInfo.targetYear }} %</td>
          <td
            *ngIf="detailInfo.expandCustomerSplitMethod !== 'BY_YEAR'"
            nzAlign="center"
            nzEllipsis
            [title]=" salesPortalService.formatThousands(detailInfo.customerActualVsTarget,true)+'%'"
          >{{ salesPortalService.formatThousands(detailInfo.customerActualVsTarget, true) }}%
          </td>
          <td
            *ngFor="let data of salesPortalService.transposeTableData(detailInfo.customerConfigurationList).actualVsTarget"
            nzAlign="center"
            nzEllipsis
          >
              <span
                [title]="salesPortalService.formatThousands(data, true) + '%'">  {{ salesPortalService.formatThousands(data, true) }}
                %</span>
          </td>
        </tr>
        <tr>
          <td>Actual. {{ detailInfo.targetYear - 1 }}</td>
          <td
            *ngIf="detailInfo.expandCustomerSplitMethod !== 'BY_YEAR'"
            nzAlign="center"
            nzEllipsis
            [title]=" salesPortalService.formatThousands(detailInfo.lastYearCustomerActualAmount)"
          >{{ salesPortalService.formatThousands(detailInfo.lastYearCustomerActualAmount) }}
          </td>
          <td
            *ngFor="let data of salesPortalService.transposeTableData(detailInfo.customerConfigurationList).lastYearActualAmount"
            nzAlign="center"
            nzEllipsis
          >
              <span
                [title]="salesPortalService.formatThousands(data)"> {{ salesPortalService.formatThousands(data) }}</span>
          </td>
        </tr>
        <tr>
          <td>Act. {{ detailInfo.targetYear }} vs. Act.  {{ detailInfo.targetYear - 1 }} %</td>
          <td
            *ngIf="detailInfo.expandCustomerSplitMethod !== 'BY_YEAR'"
            nzAlign="center"
            nzEllipsis
            [title]=" salesPortalService.formatThousands(detailInfo.customerActualVsLastYear,true) + '%'"
          >{{ salesPortalService.formatThousands(detailInfo.customerActualVsLastYear, true) }}%
          </td>
          <td
            *ngFor="let data of salesPortalService.transposeTableData(detailInfo.customerConfigurationList).actualVsLastYear"
            nzAlign="center"
            nzEllipsis
          >
              <span
                [title]=" salesPortalService.formatThousands(data, true) + '%'">{{ salesPortalService.formatThousands(data, true) }}
                %</span>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</nz-spin>



